<template>
  <el-dialog
    :title="`${titleName}占桩费费率`"
    :visible.sync="showDialog"
    :before-close="closeDialog"
    @open="closeDialogParams"
  >
    <el-form ref="form" :rules="rules" :model="form" label-width="82px">
      <el-row style="margin-bottom: 15px" v-if="form.createDate!=null">
        <el-col :span="12"> 操作人：{{ form.createUser }} </el-col>
        <el-col :span="12"> 最后更新时间：{{ form.createDate }} </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="费率名称:" prop="ruleName">
            <el-input
              size="mini"
              v-model="form.ruleName"
              autocomplete="off"
              :disabled="id !== null"
              clearable
              placeholder="请填写"
              style="width: 180px"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">

          <el-form-item label="运营商："  prop="operatorId">
            <el-select
              placeholder="运营商"
              size="mini"
              clearable
              :disabled="id !== null"
              v-model="form.operatorId"
            >
              <el-option
                v-for="item in operatorForSelect"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>


        </el-col>
      </el-row>
      <div>占桩费基本信息</div>
      <el-form-item
        label-width="121px"
        label="占桩费上限:"
        style="margin-bottom: 5px; margin-top: 10px"
        prop="haveAmountTop"
      >
        <!-- <el-radio-group
          v-model="form.haveAmountTop"
          :disabled="id !== null"
          style="margin-top: 12px"
        >
          <el-radio style="margin-left: 20px" label="N">无上限</el-radio>
          <el-radio style="margin-left: 150px; width: 0px" label="Y"
            >设置上限（元）</el-radio
          > -->
        <!-- style="width: 80px; margin: -5px 0 0 280px" -->
        <!-- :disabled="form.haveAmountTop === 'N' || id !== null" -->
        <el-input
          size="mini"
          v-model="form.amountTop"
          oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
          :disabled="id !== null"
          style="width: 280px"
        ></el-input>
        <!-- </el-radio-group> -->
      </el-form-item>
      <el-form-item
        label-width="172px"
        prop="reduceTime"
        label="占桩减免时长(分钟):"
        clearable
      >
        <el-input
          size="mini"
          oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
          v-model="form.reduceTime"
          :disabled="id !== null"
          style="width: 310px"
        ></el-input>
      </el-form-item>
      <div style="margin: 20px 0">占桩费费率设置(最多5个时段)</div>
      <el-form-item
        style="margin: 0 0 15px -80px"
        v-for="(item, index) in form.timeSlotList"
        :key="index"
      >
        <el-time-select
          style="width: 120px"
          placeholder="起始时间"
          v-model="item.beginTime"
          :disabled="id !== null"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '24:00',
          }"
        >
        </el-time-select>
        <span style="margin: 0 10px">至</span>
        <el-time-select
          style="width: 120px"
          placeholder="结束时间"
          v-model="item.endTime"
          :disabled="id !== null"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '24:00',
          }"
        >
        </el-time-select>
        <span style="margin: 0px 10px 0px 40px">占桩费价格(元/分钟):</span>
        <el-input
          v-model="item.billingPrice"
          style="width: 100px; margin-right: 20px"
          MAXLENGTH="5"
          :disabled="id !== null"
          onbeforepaste="clipboardData.setData('text',clipboardData.getData('text').replace(/[^\d]/g,''))"
          oninput="value=value.replace(/[^\d.]/g,'')"
        ></el-input>
        <el-button
          type="danger"
          size="mini"
          @click="delTimeSlotList(index)"
          v-if="id === null"
          >删除</el-button
        >
      </el-form-item>
      <el-button
        type="primary"
        style="margin: 0px 0 0 0px"
        @click="addTimeSlotList"
        v-if="form.timeSlotList.length < 5 && id === null"
        >新增</el-button
      >
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="add" v-if="id === null"
        >保 存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import OccupancyFeeApi from "../../../api/OccupancyFeeApi";
import commonApi from "../../../api/commonApi";
export default {
  name: "addPOF",
  data() {
    return {
      form: {
        ruleName: "", //费率名称
        operatorId: "", // 运营商id
        haveAmountTop: "Y", // 是否有占桩费上线
        amountTop: "", // 占桩费上限(单位元)
        reduceTime: "", // 占桩减免时长(分钟)
        timeSlotList: [], // 费率时段设置
      },
      operatorId1:"",
      operatorForSelect:[],
      titleName: "", // 弹窗title
      id: null, // 查看归档历史id
      createUser: "", // 操作人
      createDate: "", // 最后更新时间
      rules: {
        ruleName: [
          { required: true, message: "请输入费率名称", trigger: "blur" },
        ],
        operatorId: [
          { required: true, message: "请选择运营商", trigger: "change" },
        ],
        reduceTime: [
          { required: true, message: "请输入占桩减免时长", trigger: "blur" },
        ],
        haveAmountTop: [
          { required: true, message: "请选择占桩费上限", trigger: "change" },
        ],
      },
      fatherParams: null,
    };
  },
  props: {
    params: {
      type: String,
      required: true,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
  },

  created: function () {
    this.operatorId1 = sessionStorage.getItem('operatorId')
    this.loadSelectItem();
  },

  watch: {
    '$store.state.operatorId': {
      handler: function (newVal, oldVal) {
        this.operatorId1 = sessionStorage.getItem('operatorId');
        this.loadSelectItem()
      },
      deep: true
    }
  },


  methods: {

    // 加载下拉框
    loadSelectItem() {
      // 运营商下拉框

      const param= {
        "id": this.operatorId1
      }
      commonApi.getOperatorsTree(param).then((res) => {
        if (res.code === 0) {
          this.operatorForSelect = res.data
        }
      })

    },


    handleChange(value) {
      let operatorId = value && value.length > 0 ? value[value.length - 1] : "";
      this.form.operatorId = operatorId;
      this.$refs.cascader.dropDownVisible = false;
    },
    // 打开弹窗
    closeDialogParams() {
      let param = JSON.parse(this.params);
      this.titleName = param.titleName;
      if (param.titleName === "查看") {
        // console.log("调用查看");
        this.id = param.id;
        OccupancyFeeApi.findByRecordId(this.id).then((res) => {
          this.form = res.data;
          this.form.haveAmountTop = res.data.haveAmountTopCode;
        });
      }
      if (param.titleName === "编辑") {
        // console.log(param.id, param.operatorId);
        OccupancyFeeApi.findByRulesId(param.operatorId, param.id).then(
          (res) => {
            this.form = res.data;
            this.form.haveAmountTop = res.data.haveAmountTopCode;
          }
        );
      }
    },
    // 删除时段
    delTimeSlotList(index) {
      this.form.timeSlotList.splice(index, 1);
    },
    // 新增时段
    addTimeSlotList() {
      let key = {
        beginTime: "", //开始时间
        endTime: "", // 结束时间
        billingPrice: "", //占桩费价格(元/分钟)
      };
      this.form.timeSlotList.push(key);
    },
    // 添加费率
    add() {
      // if (this.form.haveAmountTop === "Y" && this.form.amountTop === "") {
      //   this.$message.error("请填写上限金额");
      //   return;
      // }
      console.log(this.titleName);
      // 兜底校验
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        if (this.titleName === "新增") {
          OccupancyFeeApi.save(this.form).then((res) => {
            if (res.code === 0) {
              this.$message.success("添加成功");
              this.$emit("update:showDialog", false);
              this.form = {
                ruleName: "", //费率名称
                operatorId: "", // 运营商id
                haveAmountTop: "Y", // 是否有占桩费上线
                amountTop: "", // 占桩费上限(单位元)
                reduceTime: "", // 占桩减免时长(分钟)
                timeSlotList: [], // 费率时段设置
              };
              this.$parent.getBillingRules();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          OccupancyFeeApi.update(this.form).then((res) => {
            if (res.code === 0) {
              console.log(res, "编辑");
              this.$message.success("编辑成功");
              this.$emit("update:showDialog", false);
              this.$emit("update:params", "");
              this.form = {
                ruleName: "", //费率名称
                operatorId: "", // 运营商id
                haveAmountTop: "Y", // 是否有占桩费上线
                amountTop: "", // 占桩费上限(单位元)
                reduceTime: "", // 占桩减免时长(分钟)
                timeSlotList: [], // 费率时段设置
              };
              this.$parent.getBillingRules();
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    // 取消关闭弹窗
    closeDialog() {
      if (this.id !== null) {
        this.$emit("update:showDialog", false);
        this.$emit("update:params", "");
        this.form = {
          ruleName: "", //费率名称
          operatorId: "", // 运营商id
          haveAmountTop: "Y", // 是否有占桩费上线
          amountTop: "", // 占桩费上限(单位元)
          reduceTime: "", // 占桩减免时长(分钟)
          timeSlotList: [], // 费率时段设置
        };
      } else {
        this.$confirm("是否要取消当前操作？")
          .then((_) => {
            this.$emit("update:showDialog", false);
            this.$emit("update:params", "");
            this.form = {
              ruleName: "", //费率名称
              operatorId: "", // 运营商id
              haveAmountTop: "Y", // 是否有占桩费上线
              amountTop: "", // 占桩费上限(单位元)
              reduceTime: "", // 占桩减免时长(分钟)
              timeSlotList: [], // 费率时段设置
            };
          })
          .catch((_) => {});
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 10px 60px 0;
  text-align: left;
}
/deep/ .el-form-item__content {
  display: flex;
  align-items: center;
}
/deep/ .el-radio__inner {
  border: 1px solid #dadada;
}
/deep/ .el-range-editor--mini.el-input__inner {
  width: 230px;
  margin-left: -40px;
}
</style>




// WEBPACK FOOTER //
// src/module/resourceCenter/page/rateManager/pileOccupation/addPOF.vue